import React, { useEffect, useState } from 'react'
import { Button, Form, Input, message, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import { MethodType } from '../../constants/MethodType'
import dayjs from 'dayjs'

const callFacebookAPI = async (url, onError = () => {}) => await axios({ url, method: MethodType.GET })
  .catch(err => {
    message.error(err?.data?.error?.message)
    onError()
  })
const checkAccessToken = async (token, onError) => await callFacebookAPI(`https://graph.facebook.com/me?access_token=${token}`, onError)
const getLatestInfo = async token => await callFacebookAPI(`https://graph.facebook.com/debug_token?access_token=${token}&input_token=${token}`)
const extendToken = async (appId, appSecret, token) => await callFacebookAPI(`https://graph.facebook.com/v22.0/oauth/access_token?grant_type=fb_exchange_token&client_id=${appId}&client_secret=${appSecret}&fb_exchange_token=${token}`)
const getAccounts = async token => await callFacebookAPI(`https://graph.facebook.com/v22.0/me/adaccounts?fields=id,account_id,name&access_token=${token}`)

const getExpiredDate = timestamp => {
  const expiredDate = dayjs.unix(timestamp)
  return expiredDate?.diff(dayjs(), 'day')
}

export const AccessTokenInput = props => {
  const { formProps, placeholder, disabled, form, setAdditionalInfo, additionalInfo, data } = props
  const { t: ln_t } = useTranslation()
  const status = additionalInfo?.accessTokenStatus
  const myVal = Form.useWatch('accessToken')

  const changeStatus = val => setAdditionalInfo(prev => ({ ...prev, accessTokenStatus: val }))

  const handleCheckToken = async accessToken => {
    const checkToken = await checkAccessToken(accessToken, () => changeStatus({ is_valid: false }))
    if (checkToken?.status !== 200) return changeStatus({ is_valid: false })

    const getInfo = await getLatestInfo(accessToken)
    if (getInfo?.status === 200) changeStatus({ ...getInfo?.data?.data, expired_day: getExpiredDate(getInfo?.data?.data?.expires_at) })
  }

  const handleCheck = async () => {
    const name = formProps?.name
    const valid = await form.validateFields([name]).catch(() => false)
    if (!valid) return
    handleCheckToken(valid[name])
  }

  const handleChangeStatus = () => {
    changeStatus({ is_valid: false })
    form.setFieldValue('accountId', undefined)
  }

  useEffect(() => {
    if (data && data?.accessToken) handleCheckToken(data?.accessToken)
  }, [])

  return <Form.Item
    key={formProps.name}
    {...formProps}
    className='label-width-100'
    label={<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
      <div>
        <span style={{ marginRight: '16px' }}>{formProps.label}</span>
        {!status || !myVal
          ? ''
          : status?.is_valid
            ? <span style={{ color: 'rgba(19, 146, 19, 1)' }}>{ln_t('export.valid')} {status?.expired_day} {ln_t('export.days')}</span>
            : <span style={{ color: 'rgba(146, 19, 19, 1)' }}>{ln_t('export.invalid')}</span>}
      </div>
      <Button type="primary" style={{ borderRadius: '24px' }} size="small" onClick={handleCheck}>{ln_t('export.check')}</Button>
    </div>}
  >
    <Input placeholder={placeholder} disabled={disabled} onChange={handleChangeStatus} />
  </Form.Item>
}

export const AccountSelector = props => {
  const { formProps, placeholder, disabled, additionalInfo, dependency, setAdditionalInfo } = props
  const dependencyVal = dependency ? Form.useWatch(dependency) : ''
  const [options, setOptions] = useState([])

  const getOptions = async () => {
    if (!dependencyVal) return
    const res = await getAccounts(dependencyVal)
    if (res?.status === 200) setOptions(res?.data?.data?.map(i => ({ value: i?.account_id, label: i?.name })))
  }

  useEffect(() => {
    if (additionalInfo?.accessTokenStatus && additionalInfo?.accessTokenStatus?.is_valid) getOptions()
  }, [additionalInfo?.accessTokenStatus])

  return <Form.Item key={formProps.name} {...formProps} name="accountId">
    <Select
      showSearch
      optionFilterProp="label"
      options={options}
      placeholder={placeholder}
      disabled={disabled || !additionalInfo?.accessTokenStatus?.is_valid}
      onChange={e => setAdditionalInfo(prev => ({ ...prev, accountName: options?.find(i => i.value === e)?.label }))}
    />
  </Form.Item>
}

export const AppIdInput = props => {
  const { formProps, placeholder, disabled, additionalInfo, setAdditionalInfo, form } = props
  const { t: ln_t } = useTranslation()
  const formVal = Form.useWatch()
  const disabledButton = !additionalInfo?.accessTokenStatus?.is_valid || !formVal?.appId || !formVal?.appSecret

  const handleExtend = async () => {
    const res = await extendToken(formVal.appId, formVal.appSecret, formVal.accessToken)
    if (res?.status !== 200) return

    const getInfo = await getLatestInfo(res?.data?.access_token)
    if (getInfo?.status === 200) {
      setAdditionalInfo(prev => ({ ...prev, accessTokenStatus: { ...getInfo?.data?.data, expired_day: getExpiredDate(getInfo?.data?.data?.expires_at) } }))
      form.setFieldValue('accessToken', res?.data?.access_token)
    }
  }

  return <Form.Item
    key={formProps.name}
    {...formProps}
    className='label-width-100'
    label={<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
      <div>{formProps.label}</div>
      <Button type="primary" style={{ borderRadius: '24px' }} size="small" disabled={disabledButton} onClick={handleExtend}>
        {ln_t('export.extend')}
      </Button>
    </div>}
  >
    <Input placeholder={placeholder} disabled={disabled} />
  </Form.Item>
}
